module.exports = __webpack_public_path__ + "img/1440.e749f526.jpg";